"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var extractStyleParts_1 = require("./extractStyleParts");
var concatStyleSets_1 = require("./concatStyleSets");
var styleToClassName_1 = require("./styleToClassName");
/**
 * Allows you to pass in 1 or more sets of areas which will return a merged
 * set of classes.
 *
 * @public
 */
function mergeStyleSets() {
    var cssSets = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        cssSets[_i] = arguments[_i];
    }
    // tslint:disable-next-line:no-any
    var classNameSet = {};
    var cssSet = cssSets[0];
    if (cssSet) {
        if (cssSets.length > 1) {
            cssSet = concatStyleSets_1.concatStyleSets.apply(void 0, cssSets);
        }
        var registrations = [];
        for (var prop in cssSet) {
            if (cssSet.hasOwnProperty(prop)) {
                var args = cssSet[prop];
                // tslint:disable-next-line:no-any
                var _a = extractStyleParts_1.extractStyleParts(args), classes = _a.classes, objects = _a.objects;
                var registration = styleToClassName_1.styleToRegistration({ displayName: prop }, objects);
                registrations.push(registration);
                if (registration) {
                    classNameSet[prop] = classes.concat([registration.className]).join(' ');
                }
            }
        }
        for (var _b = 0, registrations_1 = registrations; _b < registrations_1.length; _b++) {
            var registration = registrations_1[_b];
            if (registration) {
                styleToClassName_1.applyRegistration(registration, classNameSet);
            }
        }
    }
    return classNameSet;
}
exports.mergeStyleSets = mergeStyleSets;
//# sourceMappingURL=mergeStyleSets.js.map


//////////////////
// WEBPACK FOOTER
// ../~/@uifabric/merge-styles/lib/mergeStyleSets.js
// module id = ../node_modules/@uifabric/merge-styles/lib/mergeStyleSets.js
// module chunks = 1